module.exports = __webpack_public_path__ + "static/media/glory.d3b13604.png";